function ExecuteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_10183_16363"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path d="M2 2H22V22H2V2Z" fill="white" />
      </mask>
      <g mask="url(#mask0_10183_16363)">
        <path
          d="M16.6875 12C16.6875 11.5665 16.6093 11.1546 16.4986 10.7559L17.6603 10.0852L16.4885 8.05543L15.3393 8.71891C14.7533 8.12254 14.0053 7.69558 13.1719 7.47894V6.14062H10.8282V7.47894C9.9948 7.69558 9.24675 8.12254 8.66074 8.71891L7.5116 8.05543L6.33972 10.0852L7.50144 10.7559C7.39078 11.1546 7.31253 11.5665 7.31253 12C7.31253 12.4335 7.39078 12.8454 7.50144 13.2441L6.33972 13.9148L7.5116 15.9446L8.66074 15.2811C9.24675 15.8775 9.9948 16.3044 10.8282 16.5211V17.8594H13.1719V16.5211C14.0053 16.3044 14.7533 15.8775 15.3393 15.2811L16.4885 15.9446L17.6603 13.9148L16.4986 13.2441C16.6093 12.8454 16.6875 12.4335 16.6875 12Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 14.3438C10.7074 14.3438 9.65625 13.2926 9.65625 12C9.65625 10.7074 10.7074 9.65625 12 9.65625C13.2926 9.65625 14.3438 10.7074 14.3438 12C14.3438 13.2926 13.2926 14.3438 12 14.3438Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.30898 15.5156C2.86801 14.4295 2.58594 13.2426 2.58594 12C2.58594 6.8307 6.8307 2.58594 12 2.58594C14.9609 2.58594 17.7384 4.0491 19.4578 6.19953"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6911 8.48438C21.1321 9.57055 21.4141 10.7574 21.4141 12C21.4141 17.1693 17.1694 21.4141 12.0001 21.4141C9.03913 21.4141 6.26163 19.9509 4.5423 17.8005"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6291 3.71328L19.4577 6.19922L16.9718 5.37055"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.02811 18.6279L4.54218 17.7993L5.37081 20.2852"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default ExecuteIcon;
